import React, { Component } from 'react';
import ReactLoading from 'react-loading';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ResponseRedirect.css';

import {getRedirectedRequest} from './ResponseRedirectAPI';

class ResponseRedirect extends Component {

  static defaultProps = {
    redirectId : null,
  }

  state = {
    requestText : "Loading...",
  }

  componentDidMount() {
    const { callBackGetRequest } = this;
    const { redirectId } = this.props;
    
    getRedirectedRequest(callBackGetRequest, redirectId);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { redirectId } = nextProps;
    const currentRedirectId = this.props.redirectId;

    if ( currentRedirectId !== redirectId ) {
      const { callBackGetRequest } = this;
      getRedirectedRequest(callBackGetRequest, redirectId);
    }

    return true;
  }

  callBackGetRequest = (response) => {
    
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const {property} = data;
      const {request} = property;
      
      this.setState({
        requestText : request,
      })
      break;

      case 403:
      const { subCode } = data

      switch(subCode)  {
        case 0:
        alert("접근할 수 없는 리퀘스트입니다.");
        break;

        case 1:
        alert("존재하지 않는 리퀘스트입니다.");
        break;

        default:
        alert("에러가 발생하였습니다.");
      }
      break;

      case 500:
      alert("서버에서 에러가 발생하였습니다. 잠시 후 다시 시도해주세요");
      break;

      default:
      alert("에러가 발생하였습니다.");
      
    }
  }

  handleRedirectOnClick = (e) => {
    const {toggleRedirectModal} = this.props;
    toggleRedirectModal();
  }

  renderRedirectedRequest = (request) => {
    const { requestText } = request;
    
    if (!requestText) {
      return (
        <ReactLoading type={"bars"} width={30} height={30} color="black" />
      );
    }

    return (
      <h5 className="redirect-req"> {requestText} </h5>
    );
  }

  render() {
    const { handleRedirectOnClick } = this;
    const { renderRedirectedRequest } = this;
    const { requestText } = this.state;

    const renderedRedirectedRequest = renderRedirectedRequest({
      requestText : requestText,
    });
    
    return (
      <div id="ResponseRedirect"
        onClick={handleRedirectOnClick} >
        {renderedRedirectedRequest}
      </div>
    );
  }
}

export default ResponseRedirect;